import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Location } from '../../../api/location/location';

@Component({
    selector: 'location-details',
    templateUrl: './location-details.component.html',
    styleUrls: ['./location-details.component.css'],
    host: {'class': 'location-details'},
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LocationDetailsComponent {
  @Input() location: Location | null | undefined = null;
}
